import { Box, Container, Center, Heading, Stack, Button, Link } from '@chakra-ui/react';
import { NoteArticleAPIResponse } from '@/hooks/use-note-article-data';
import React from 'react';
import { TFunction } from 'i18next';

interface BlogProps {
  t: TFunction;
  articles: NoteArticleAPIResponse[];
}

const Blog: React.VFC<BlogProps> = ({ t, articles }) => {
  return (
    <Box as="section" bg="blue.500" pb="8">
      <script async src="https://note.com/scripts/embed.js" />
      <Box
        bg="teal.500"
        h="70px"
        mt="-35px"
        sx={{ transformOrigin: '100% 0', transform: 'skewY(-1deg)' }}
      />
      <Box as="section" bg="teal.500" py="50px" scrollSnapAlign="start">
        <Container h="100%" maxW="container.xl">
          <Center mb="12">
            <Heading as="h3" color="white" size="2xl">
              {t('pretia_note_article')}
            </Heading>
          </Center>
          <Stack align="center" h="100%" justify="center" spacing="4">
            {articles.map((a) => (
              <Box
                key={a.key}
                _hover={{ filter: 'brightness(105%)' }}
                h="230px"
                maxW="700px"
                w="100%">
                <iframe
                  height="100%"
                  src={`https://note.com/embed/notes/${a.key}`}
                  title={a.title}
                  width="100%"
                />
              </Box>
            ))}
            <Link href="https://note.com/pretia_tech" target="_blank" variant="no-decoration">
              <Button
                colorScheme="blue"
                mt="8"
                rounded="full"
                variant="invert-solid"
                w="400px"
                size="lg">
                {t('see_more')}
              </Button>
            </Link>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Blog;
